import { AnimatePresence, motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { toggle } from "../../services/navigationSlice";
import styled from "styled-components";
import { Mobilemenu, Usermenu } from "../../layouts";
import closeMenu from "../../assets/closeMenu.svg";
import "../../styles/navbar.css";
import { selectUser } from "../../services/userSlice";

interface RootState {
  navigation: {
    isClicked: boolean;
  };
}

const CloseDiv = styled.div`
  display: flex;
  padding-bottom: 2em;
  align-items: center;
`;

const Navbar = () => {
  const navigate = useSelector(
    (state: RootState) => state.navigation.isClicked,
  );
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(toggle());
  };
  const user = useSelector(selectUser);

  return (
    <AnimatePresence>
      {navigate && (
        <motion.nav
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="styledNav"
        >
          <div className="all-menu">
            <CloseDiv onClick={handleClick}>
              <img
                src={closeMenu}
                alt="close-menu"
                className="closeMenu"
              />
              <h4>Close menu</h4>
            </CloseDiv>

            {!user?.emailVerified && <Mobilemenu handleClick={handleClick} />}
            {user?.emailVerified && <Usermenu />}

            {/* to be rendered conditionally on user login  */}
          </div>
          <div className="mobile-menu-square"></div>
        </motion.nav>
      )}
    </AnimatePresence>
  );
};

export default Navbar;
